<template>
  <div>
    <v-row align="center" class="mb-1">
      <v-col cols="4">
        <v-text-field
          v-model="ricerca"
          prepend-inner-icon="mdi-magnify"
          label="Cerca cliente…"
          outlined
          dense
          hide-details
          clearable
        />
      </v-col>
      <v-col cols="3">
        <v-switch
          v-model="nascondi_evase"
          inset
          dense
          hide-details
          label="Nascondi evase"
          class="mt-0"
        />
      </v-col>
      <v-col cols="5" class="text-right grey--text text-caption">
        {{ prenotazioni.length }} di {{ totale_prenotazioni }}
      </v-col>
    </v-row>

    <v-divider class="mb-2" />
    <v-row no-gutters class="font-weight-medium grey--text text-caption pb-2">
      <v-col cols="1" class="pl-2">#</v-col>
      <v-col cols="3">Cliente</v-col>
      <v-col cols="2">Consegna</v-col>
      <v-col cols="1">Modalità</v-col>
      <v-col cols="1" class="text-right">CC</v-col>
      <v-col cols="2" class="text-right pr-4">Totale</v-col>
      <v-col cols="1">Stato</v-col>
      <v-col cols="1"></v-col>
    </v-row>
    <v-divider class="mb-1" />

    <div v-if="caricamento" class="py-12 d-flex justify-center">
      <v-progress-circular indeterminate color="green" />
    </div>

    <div v-else-if="!prenotazioni.length" class="py-12 text-center grey--text">
      <template v-if="totale_prenotazioni">
        Nessuna prenotazione corrisponde ai filtri.
      </template>
      <template v-else>Nessuna prenotazione per il {{ anno }}.</template>
    </div>

    <template v-else>
      <v-lazy
        v-for="prenotazione in prenotazioni"
        :key="prenotazione.id"
        :min-height="48"
        :options="{ threshold: 0.4 }"
        transition="fade-transition"
      >
        <PrenotazioneRiga
          :prenotazione="prenotazione"
          @apri="$emit('apri', prenotazione.id)"
          @errore="$emit('errore', $event)"
        />
      </v-lazy>

      <!-- Le colonne ricalcano quelle della riga: 1 + 3 + 2 + 1 = 7 prima
           del CC, altrimenti i totali cadono una colonna più a sinistra. -->
      <v-row no-gutters class="mt-4 font-weight-bold totali">
        <v-col cols="1" offset="7" class="text-right">{{ totale_cc }}</v-col>
        <v-col cols="2" class="text-right pr-4">{{ totale_valore }} €</v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import PrenotazioneRiga from "./PrenotazioneRiga.vue";

const PREF_NASCONDI = "cris_nascondi_evase";

export default {
  components: { PrenotazioneRiga },

  props: {
    anno: { type: String, required: true },
    caricamento: { type: Boolean, default: false },
  },

  data() {
    return {
      ricerca: "",
      // Ripresa dalle preferenze: quella storica la scriveva senza rileggerla
      // mai, quindi la scelta si perdeva a ogni ricaricamento.
      nascondi_evase: localStorage.getItem(PREF_NASCONDI) === "true",
    };
  },

  computed: {
    tutte() {
      return this.$store.getters["crisantemi/tutte"];
    },

    totale_prenotazioni() {
      return this.tutte.length;
    },

    prenotazioni() {
      const q = (this.ricerca || "").trim().toLowerCase();
      return this.tutte
        .filter((p) => !this.nascondi_evase || !p.evasa)
        .filter((p) => {
          if (q.length < 2) return true;
          const c = this.$store.getters.get_cliente_by_iva(p.cliente);
          if (!c) return false;
          return (
            (c.nome || "").toLowerCase().includes(q) ||
            String(c.numero || "").includes(q)
          );
        })
        .slice()
        .sort((a, b) => this.numero_di(a) - this.numero_di(b));
    },

    totale_cc() {
      return this.prenotazioni
        .reduce(
          (tot, p) =>
            tot + this.$store.getters["crisantemi/cc"]({ id_prenotazione: p.id }),
          0
        )
        .toFixed(1);
    },

    totale_valore() {
      return this.prenotazioni
        .reduce((tot, p) => tot + this.$store.getters["crisantemi/valore"](p.id), 0)
        .toFixed(2);
    },
  },

  watch: {
    nascondi_evase(valore) {
      localStorage.setItem(PREF_NASCONDI, valore);
    },
  },

  methods: {
    numero_di(prenotazione) {
      const c = this.$store.getters.get_cliente_by_iva(prenotazione.cliente);
      const n = c ? parseInt(c.numero) : NaN;
      // I clienti senza numero vanno in fondo invece che in testa.
      return isNaN(n) ? Number.MAX_SAFE_INTEGER : n;
    },
  },
};
</script>

<style scoped>
.totali {
  font-variant-numeric: tabular-nums;
}
</style>
